<template>
    <div
        class="md-testimionial-star review-star"
        :class="`${cls}`"
        :aria-label="`Score: ${score} out of 5`"
    >
        <i
            v-for="i in newScoreNum"
            :key="i"
            class="iconfont"
            :class="[{ active: score >= i },iconName]"
            :style="iconStyle"
            aria-hidden="true"
        ></i>
    </div>
</template>

<script>
import { REVIEW_SOURCE_KEY } from './constants';
export default {
    name: 'ReviewStar',
    i18next: {
        ns: 'md-testimonial'
    },
    props: {
        onlyShowActiveScore: {
            type: Boolean,
            default: true
        },
        sourceType: {
            type: Number,
            default: 0
        },
        score: {
            type: Number,
            default: 5
        },
        iconName: {
            type: String,
            default: 'icon-star-fill'
        },
        iconSize: {
            type: Number,
            default: 16
        },
        iconSpace: {
            type: Number,
            default: 8
        }
    },
    computed: {
        newScoreNum() {
            return this.onlyShowActiveScore ? this.score : 5;
        },
        cls() {
            return REVIEW_SOURCE_KEY[this.sourceType]?.toLowerCase();
        },
        iconStyle() {
            return {
                fontSize: this.iconSize + 'px',
                marginRight: this.iconSpace + 'px'
            };
        }
    }
};
</script>

<style lang="scss">
.md-testimionial-star.review-star {
    display: flex;
    align-items: center;
    .icon-star-fill {
        color: #c9c9c9;
        font-size: 16px;
        margin-right: 8px;
        &:last-child {
            margin-right: 0 !important;
        }
        &.active {
            color: #ff973b;
        }
    }
    &.default,
    &.gmb {
        .icon-star-fill {
            &.active {
                color: #ff973b;
            }
        }
    }
    &.zillow {
        .icon-star-fill {
            &.active {
                color: #3075e5;
            }
        }
    }
    &.rma {
        .icon-star-fill {
            &.active {
                color: #ffd119;
            }
        }
    }
}
</style>
